import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2213685c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 1,
  class: "wrapper"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_list = _resolveComponent("van-list");
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
  const _component_van_empty = _resolveComponent("van-empty");
  return _ctx.listPagination.data.length ? (_openBlock(), _createBlock(_component_van_pull_refresh, {
    key: 0,
    modelValue: _ctx.listPagination.isListRefreshIng,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.listPagination.isListRefreshIng = $event),
    onRefresh: _ctx.onListRefresh
  }, {
    default: _withCtx(() => [_createVNode(_component_van_list, {
      loading: _ctx.listPagination.isListLoading,
      "onUpdate:loading": _cache[0] || (_cache[0] = $event => _ctx.listPagination.isListLoading = $event),
      error: _ctx.listPagination.isListLoadingError,
      "onUpdate:error": _cache[1] || (_cache[1] = $event => _ctx.listPagination.isListLoadingError = $event),
      "error-text": "请求失败，点击重新加载",
      "finished-text": _ctx.listPagination.data >= _ctx.listPagination.pageSize ? '没有更多了' : '',
      "immediate-check": $props.immediateCheck,
      finished: _ctx.listPagination.isListFinished,
      onLoad: _ctx.onListLoad
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listPagination.data, (item, index) => {
        return _renderSlot(_ctx.$slots, "default", _normalizeProps(_guardReactiveProps({
          item,
          index
        })), undefined, true);
      }), 256))]),
      _: 3
    }, 8, ["loading", "error", "finished-text", "immediate-check", "finished", "onLoad"])]),
    _: 3
  }, 8, ["modelValue", "onRefresh"])) : (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_empty, {
    image: "search",
    description: "空空如也"
  })]));
}